// Rendered when an org admin navigates to a module that exists in the
// registry but is currently disabled (no subscription item, no entitlement
// override). Pitches the module's price and links to the billing settings
// page where the user can run Checkout.

import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { formatCents, listModulePricesPublic } from '@pc/db';
import { Button, Card, SmallCap } from '@pc/ui';

export function ModuleNotOnPlanPage({ moduleId, label }: { moduleId: string; label: string }) {
  const q = useQuery({ queryKey: ['operator', 'module-prices'], queryFn: listModulePricesPublic });
  const price = (q.data ?? []).find((m) => m.module_id === moduleId);

  return (
    <div className="max-w-2xl">
      <SmallCap>Module locked</SmallCap>
      <h1 className="display text-3xl mt-2">
        {label} is <em>not on your plan</em>.
      </h1>
      <p className="mt-4 text-sm text-ink-2 max-w-prose">
        This area is part of the {label} module. Add it to your subscription to access{' '}
        {label.toLowerCase()} features for everyone in your workspace.
      </p>
      <Card className="mt-8" title={`${label} module`}>
        {price ? (
          <div className="flex flex-col gap-3">
            {price.description ? <p className="text-sm text-ink-2">{price.description}</p> : null}
            <p className="text-ink">
              <strong>{formatCents(price.monthly_unit_amount_cents)}</strong> per month or{' '}
              <strong>{formatCents(price.yearly_unit_amount_cents)}</strong> per year.
            </p>
            <div>
              <Link to="/settings/billing">
                <Button>Add to subscription</Button>
              </Link>
            </div>
          </div>
        ) : (
          <p className="text-sm text-muted">
            Module pricing not configured yet. Contact support to add this module.
          </p>
        )}
      </Card>
    </div>
  );
}
